import { useState, useEffect } from 'react';
import { IconButton, Button } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Alerts from '../alerts/Alerts';
import '../../styles/components/AlertCarousel.css';

function AlertCarousel({ banners = [] }) {
    const [currentBanner, setCurrentBanner] = useState(0);

    // Auto-swipe effect
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentBanner((prev) => (prev === banners.length - 1 ? 0 : prev + 1));
        }, 10000);

        return () => clearInterval(interval);
    }, [banners.length]);

    function handlePrevBanner() {
        setCurrentBanner((prev) => {
            if (prev === 0) {
                return banners.length - 1; // Loop to the last banner
            }
            return prev - 1; // Go to the previous banner
        });
    }

    function handleNextBanner() {
        setCurrentBanner((prev) => {
            if (prev === banners.length - 1) {
                return 0; // Loop to the first banner
            }
            return prev + 1; // Go to the next banner
        });
    }

    return (
        <section id="incomplete-process-carousel-container">
            <div className="carousel-wrapper">
                {banners.length > 1 && (
                    <div className="carousel-left-button">
                        <IconButton sx={swipeBtnStyle} onClick={handlePrevBanner}>
                            <ChevronLeftIcon sx={{ fontSize: '1.25rem' }} />
                        </IconButton>
                    </div>
                )}
                <div className="process-banners-container">
                    <Alerts
                        key={banners[currentBanner]?.id}
                        bannerText={banners[currentBanner]?.bannerText}
                        buttonText={banners[currentBanner]?.buttonText}
                        onClick={banners[currentBanner]?.onClick}
                    />
                </div>
                {banners.length > 1 && (
                    <div className="carousel-right-button">
                        <IconButton sx={swipeBtnStyle} onClick={handleNextBanner}>
                            <ChevronRightIcon sx={{ fontSize: '1.25rem' }} />
                        </IconButton>
                    </div>
                )}
            </div>
            {banners.length > 1 && (
                <div className="incomplete-process-dots-container">
                    {banners.map((_, idx) => (
                        <Button
                            key={idx}
                            variant="contained"
                            sx={{
                                ...swipeDotsBtnStyle,
                                backgroundColor:
                                    currentBanner === idx
                                        ? 'var(--secondary-color)'
                                        : 'rgba(255, 255, 255, 0.15)'
                            }}
                            onClick={() => setCurrentBanner(idx)}
                        />
                    ))}
                </div>
            )}
        </section>
    );
}

export default AlertCarousel;

const swipeBtnStyle = {
    padding: '0',
    border: '1px solid rgba(255, 255, 255, 0.15)'
};

const swipeDotsBtnStyle = {
    boxShadow: 'none',
    backgroundColor: 'rgba(255, 255, 255, 0.15)',
    padding: '0.25rem',
    minWidth: '0'
};
